export function normalizeBrushLayers(value: number) {
  if (!Number.isFinite(value)) return 1;
  const count = Math.max(1, Math.min(9, Math.round(value)));
  return count % 2 ? count : count - 1;
}

/** Symmetric consecutive slices; clip at the image boundary without shifting. */
export function brushLayerRange(center: number, count: number, size: number): [number, number] {
  const half = (normalizeBrushLayers(count) - 1) / 2;
  return [Math.max(0, Math.round(center) - half), Math.min(size - 1, Math.round(center) + half)];
}
